import React, { useState } from "react";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import Textarea from "../../../components/FormComponents/Textarea";

const SlackTemplateEditor = ({ file, templateData, setTemplateData }) => {
  const [isSaving, setIsSaving] = useState(false);
  const { isDirty, markClean } = useDirtyChecker(templateData);

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const payload = {
        ...templateData,
        name: file.name
      };
      const res = await axiosInstance.patch(`/slack/${file.id}`, payload);
      toastSuccess(res?.message || "Template saved successfully.");
      markClean();
    } catch (err) {
      handleApiError(err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="d_flex flex_column">
      <GenericActionBar
        path={
          <div>
            <em>Slack Templates</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSave
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />

      <div className="template_form_outer">
        <div className="builder_form">
          <Textarea
            label="Body"
            name="body"
            value={templateData.body}
            onChange={(e) => setTemplateData((prev) => ({ ...prev, body: e.target.value }))}
            style={{ height: "300px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default SlackTemplateEditor;
